import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { FC } from 'react';

interface VendorAccount {
  vendorId: number;
  volume: number;
}

const VendorVolume: FC<{ label: string; volume?: number }> = ({ label, volume }) => {
  const fontWeight = volume && volume > 0 ? 'bolder' : undefined;
  return (
    <ListItem>
      <ListItemText
        primary={label}
        primaryTypographyProps={{ fontWeight, fontSize: 20 }}
        secondary={`${volume ?? 0}%`}
        secondaryTypographyProps={{ fontWeight, fontSize: 16 }}
      />
    </ListItem>
  );
};

export const VendorSummary: FC<{ vendors: VendorAccount[] }> = ({ vendors }) => {
  const telnyx = vendors.find((x) => x.vendorId == 1 && x.volume > 0);
  const vonage = vendors.find((x) => x.vendorId == 2 && x.volume > 0);

  const telnyxVolume = telnyx?.volume ?? 0;
  const vonageVolume = vonage?.volume ?? 0;

  return (
    <>
      <VendorVolume label="Twilio" volume={100 - telnyxVolume - vonageVolume} />
      <VendorVolume label="Telnyx" volume={telnyx?.volume} />
      <VendorVolume label="Vonage" volume={vonage?.volume} />
    </>
  );
};
